import React, { PureComponent } from "react";
import { Modal, Announcement, Icon, Link, Button } from "@ss/mtd-react3";
import {
    TeamUploadFileList,
    PersonUploadFileList,
    assetTypeList
} from "@/utils/constant/teamManagement";
import "./style.scss";
import qs from "qs";
import { withRouter } from "react-router-dom";
import { getIconfontOrignLink } from "@/utils";

class UploadModal extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            isAICaseShow: true,
            uploadFileList: [],
            teamId: ""
        };
    }

    componentDidMount() {
        const { teamId } = this.props;
        this.setState({
            uploadFileList: teamId ? TeamUploadFileList : PersonUploadFileList,
            isAICaseShow:
                JSON.parse(localStorage.getItem("isAICaseShow")) ?? true
        });
    }

    handleSelectFileType = (activeFileType, childType, e) => {
        if (activeFileType === "12" && !childType) {
            return;
        }
        if (e) {
            e.stopPropagation();
        }
        const { teamId, closeModel } = this.props;
        const queryObj = {
            teamId,
            resourceType: activeFileType,
            childType
        };
        const queryString = qs.stringify(queryObj, { skipNulls: true });

        this.props.history.push(`/upload?${queryString}`);
        closeModel();
    };

    handleCloseAiTips = () => {
        localStorage.setItem("isAICaseShow", JSON.stringify(false));
    };
    handleToBrandUpload = type => {
        if (type === "5") {
            this.props.history.push(`/brand-guidelines/upload?type=${type}`); // 假设路由路径为 /brand-upload
        }
        if (type === "15") {
            this.props.history.push(`/in-app-specs/upload?type=${type}`); // 假设路由路径为 /brand-upload
        }
        if (type === "18") {
            this.props.history.push(`/brand-designs/upload?type=${type}`); // 假设路由路径为 /brand-upload
        }
    };
    render() {
        const { uploadFileList, isAICaseShow } = this.state;
        const { closeModel } = this.props;
        const title = (
            <span>
                Please ensure the assets are free of IP infringement risks
                before uploading. See details in:{" "}
                <Link
                    size="small"
                    className="link"
                    shape="text"
                    type="primary"
                    href="/assets-internal/terms-of-use"
                    target="_blank"
                >
                    Keeta Brand Assets Terms and Conditions
                </Link>
            </span>
        );
        return (
            <Modal
                title="Choose the type of asset you upload"
                onClose={closeModel}
                closable={true}
                className="upload-modal-wrap"
            >
                <Modal.Body>
                    <Announcement
                        title={title}
                        showIcon
                        type="warning"
                        style={{ marginBottom: "16px" }}
                    />
                    <ul className="upload-modal-body">
                        {assetTypeList.map(item => (
                            <li
                                key={item.value}
                                className="item-wrap"
                                // onClick={() => this.setState({ activeFileType: item.value })}
                                onClick={() =>
                                    this.handleToBrandUpload(item.value)
                                }
                            >
                                <img src={item.picUrl} loading="lazy" />
                                <div className="file-resource-wrap">
                                    <span>{item.label}</span>
                                    <span className="describtion-title">
                                        {item.describe}
                                    </span>
                                </div>
                            </li>
                        ))}
                    </ul>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        style={{ marginRight: "12px" }}
                        onClick={closeModel}
                    >
                        Cancel
                    </Button>
                    <Button type="primary">Continue</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default withRouter(UploadModal);
